import React from "react";

export default function GraphTooltipContainer({ data = [] }) {
  return (
    <ul>
      {data.map((points, index) => (
        <>
          <li key={points}>{`${points}.`}</li>
          {index < data.length - 1 && <br />}
        </>
      ))}
    </ul>
  );
}
